// ComplexOrderHistoryScreen.tsx
import React from "react";
import { useNavigate } from "react-router-dom";
import { MdPlaylistAdd } from "react-icons/md";
import { useTheme } from "../../../common/hooks/useTheme";
import { useComplexRepeatOrder } from "../useComplexRepeatOrder";
import { MobileHeader } from "../../../common/components/mobileHeader/MobileHeader";
import { ProductHeader } from "../../../common/components/productHeader/ProductHeader";
import { EmptyState } from "../../../common/components/emptyState/EmptyState";
import styles from "./ComplexOrderHistoryScreen.module.scss";
import { ROUTES } from "../../../common/utils/constants";
import { PageMeta } from "../../../common/components/pageMeta/PageMeta";
import { useComplexOrderHistory } from "./hooks/useComplexOrderHistory";
import ComplexOrderHistoryItem from "./components/complexOrderHistoryItem/ComplexOrderHistoryItem";

export default function ComplexOrderHistoryScreen() {
  const { theme } = useTheme();
  const navigate = useNavigate();
  const { orders, refreshing, getList, getOrderStatusInfo } =
    useComplexOrderHistory();
  const { repeatOrder } = useComplexRepeatOrder();

  const handlePress = (orderId: number) => {
    navigate(`${ROUTES.COMPLEX_ORDER_DETAILS}/${orderId}`);
  };

  const subtitle = orders.length > 0 ? `${orders.length} заяв.` : "Ваши заявки";

  return (
    <div
      className={styles.container}
      style={{ backgroundColor: theme.background }}
    >
      <PageMeta />

      <div className={styles.mobileOnly}>
        <MobileHeader title="Мои заявки" subtitle={subtitle} />
      </div>

      <div className={styles.desktopOnly}>
        <ProductHeader
          title="Мои заявки"
          isFavorite={false}
          showFavorite={false}
          textColor={theme.text}
          borderColor={theme.border}
        />
      </div>

      <div className={styles.content}>
        {orders.length === 0 ? (
          <EmptyState
            icon={MdPlaylistAdd}
            title="Заявок пока нет"
            description="Здесь появятся ваши проектные заявки"
          />
        ) : (
          <div className={styles.ordersList}>
            {orders.map((order) => (
              <ComplexOrderHistoryItem
                key={order.id}
                order={order}
                onPress={handlePress}
                onRepeat={repeatOrder}
                getOrderStatusInfo={getOrderStatusInfo}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
